import { capitalize } from 'lodash';

import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';
import { Button } from '@/components/ui/button';
import { EscrowAlertBadge } from '@/components/Escrow/AlertBadge';
import { TaskCriticalityEnum } from 'src/graphql/schema';

const criticalityToVariant = {
  [TaskCriticalityEnum.High]: 'alert' as const,
  [TaskCriticalityEnum.Medium]: 'warning' as const,
};

const CriticalityTooltip = ({ type }: { type: TaskCriticalityEnum }) => {
  if (type === TaskCriticalityEnum.Low) return null;

  const badgeVariant = criticalityToVariant[type];

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button size="icon" variant="ghost" className="size-7">
            <EscrowAlertBadge variant={badgeVariant} />
          </Button>
        </TooltipTrigger>
        <TooltipContent
          side="right"
          align="center"
          className="max-w-[281px] bg-white text-sm text-popover-foreground shadow-md border-border"
        >
          {capitalize(type)} criticality
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CriticalityTooltip;
